import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants, links, compose, mixpanel } from 'common/helpers'
import { useEffect } from 'sb-hooks'
import { Message } from 'sb-react-intl'

import injectGlobals from 'decorators/injectGlobals'

import { Button, buttonMessages } from 'components/_new/controls'
import Modal from 'components/modal/Modal/Modal'
import Countdown from 'components/ui/countdown/NotSubscribedCountdown/NotSubscribedCountdown'

import messages from './messages'
import s from './FirstTimeVisitModal.scss'


const FirstTimeVisitModal = ({ name, isMobile, gender, pathname, isCountdownStarted }) => {
  const isFemale = gender === 'female'
  const type = 'timer popup 1'

  const setClosedPopup = () => {
    actions.models.ui.setClosedPopup(constants.modals.FirstTimeVisit)
  }

  const handleButtonClick = () => {
    mixpanel.track(constants.analyticsEvents.visitPopupClick, {
      placement: type,
    })

    actions.view.paymentPage.setCouponWithForcedLowerValue(true)
    actions.misc.cookies.setItem(constants.cookieNames.discountCoupon, constants.discountCoupons['25_off'])

    setClosedPopup()
    actions.models.modals.close(name)
  }

  const handleModalClose = () => setClosedPopup()

  useEffect(() => {
    mixpanel.track(constants.analyticsEvents.visitPopup, {
      offer: '25%',
      placement: pathname,
      gender,
      type,
    })

    if (!isCountdownStarted) {
      actions.models.ui.setClosedPopup(constants.popups.notSubscribedCountdown)
    }
  }, [ gender, isCountdownStarted, pathname ])

  return (
    <Modal
      className={s.modal}
      contentClassName={s.modalContent}
      name={name}
      fullScreenOnMobile={false}
      withWhiteCloseButton
      onClose={handleModalClose}
    >
      <div className={s.content}>
        <Countdown className={s.countdown} />
        <Message className={s.title} tag="div" text={messages.title} />
        <Button
          className={s.button}
          title={buttonMessages.subscribe}
          to={links.subscribe}
          color={isFemale ? 'white' : 'brand'}
          size={isMobile ? 'sm' : 'md'}
          dataTestId="subscribeButton"
          onClick={handleButtonClick}
        />
        <Message className={s.hint} text={messages.hint} tag="div" />
      </div>
    </Modal>
  )
}

FirstTimeVisitModal.propTypes = {
  name: PropTypes.string.isRequired,
  isMobile: PropTypes.bool, // @injectGlobals
  gender: PropTypes.string, // @connect
  pathname: PropTypes.string, // @connect
  isCountdownStarted: PropTypes.bool, // @connect
}

FirstTimeVisitModal.defaultProps = {
  name: constants.modals.FirstTimeVisit,
  isMobile: false,
  isCountdownStarted: false,
}


export default compose(
  injectGlobals(({ globals: { device: { isMobile } } }) => ({
    isMobile,
  })),
  connect({
    gender: 'models.me.gender',
    pathname: 'routing.location.pathname',
    isCountdownStarted: (state) => {
      const { models: { ui: { closedPopups: { [constants.popups.notSubscribedCountdown]: countdownData } } } } = state

      // if countdownData exists then countdown is started
      return Boolean(countdownData && countdownData.count)
    },
  })
)(FirstTimeVisitModal)
